import React, { type ReactNode } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';

type Props = {
	fallback: 'flag' | 'unmount';
	eventLocation: string;
	children: ReactNode;
	onError?: (location: string, error: Error) => void;
};

export const NonCriticalErrorBoundary = ({ fallback, eventLocation, children, onError }: Props) => (
	<JSErrorBoundary
		fallback={fallback}
		packageName="jiraSoftwareReleasesLaunchCard"
		teamName="fusion-solaris"
		id={eventLocation}
		onError={onError}
	>
		{children}
	</JSErrorBoundary>
);
